import { render } from "./CarouselComments.vue?vue&type=template&id=09be3678&scoped=true"
import script from "./CarouselComments.vue?vue&type=script&lang=js"
export * from "./CarouselComments.vue?vue&type=script&lang=js"

import "./CarouselComments.vue?vue&type=style&index=0&id=09be3678&lang=scss&scoped=true"

import exportComponent from "C:\\GoogleDrive\\Projects\\Vue\\_published\\ksaien\\ksaien\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09be3678"]])

export default __exports__